import { useEffect, useState } from "react";
import { pcenterAPI } from '../../api/pcenterAPI';

export default function AllPcode({ setSelectedPcode, loggedPcode }) {
    const [pcodes, setPcode] = useState([]);
    const [selectedValue, setSelectedValue] = useState(loggedPcode);

    useEffect(() => {
        pcenterAPI.getPcenters().then((data) => {
            setPcode(data);
            if (data.some(p => p.pCode === loggedPcode)) {
                setSelectedValue(loggedPcode);
            }
        });
    }, [loggedPcode]);

    const onChangePCode = (e) => {
        setSelectedValue(e.target.value);
        setSelectedPcode(e.target.value);
    };


    return (
        <select className="form-select" onChange={onChangePCode} value={selectedValue}>
            <option value="">Select a center</option>
            {
                pcodes.map((data) => (
                    <option key={data.pCode} value={data.pCode}>{data.pName}</option>
                ))
            }
        </select>
    );
}